import React, { useState } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import CodeEditor from "@uiw/react-textarea-code-editor";

const Customize = ({ tracking, print }) => {
    const [state, setState] = useState({
        custom_core_data: JSON.stringify({
            "event_name": "page_view",
            "event_timestamp": "1654589080",
            "page_name": "tes",
            "page_urlpath": "http:tes.com",
            "previous_page": "Home",
            "previous_page_urlpath": "",
        }, undefined, 4),
        custom_user_data: JSON.stringify({
            "session_id": "7d32c247-b8aa-4c35-bfc9-98062ddcff81-1632455965352",
            "user_id": "999",
        }, undefined, 4),
        custom_application_data: JSON.stringify({
            "source_name": "web",
            "os_name": "Windows",
            "os_version": "Windows version",
            "browser_name": "Chrome 95"
        }, undefined, 4),
        custom_marketing_data: JSON.stringify({
            "utm_raw": "https://www.klikindomaret.com/product/body-scent-spray-cologne?utm_source=facebook&utm_medium=banner&utm_campaign=product_kecantikan_20220323&utm_id=12345&utm_term=running&utm_content=product_kecantikan"
        }, undefined, 4),
        url: "https://us-central1-idm-klik-dev.cloudfunctions.net/klikidm_apps_tracker_gateway",
        params: JSON.stringify({
            // "x-api-key": "fT2vJnJu4dsxTRMphdHE3Z92uwjaBRztGR3ECdRQTEyDDZJGbvGu",
            'Content-Type': 'application/json',
        }, undefined, 4)
    })
    const [custom, setCustom] = useState({
        core_data: true,
        user_data: false,
        application_data: false,
        marketing_data: false
    })
    const clickCustom = async (e, type) => {
        const { name } = e.target
        setCustom(prev => ({
            ...prev,
            [name]: !prev[name]
        }))
    }
    const handleChange = (e) => {
        const { value, name } = e.target
        setState(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const handleSubmit = () => {
        const arr = Object.keys(custom)
        const isState = arr.reduce((key, item, id) => {
            return {
                ...key,
                [custom[item] && "custom_" + item]: JSON.parse(state["custom_" + item])
            }
        }, {})
        delete isState.false
        const JSONCONSTANT = {
            types: state.types,
            ...isState,
            url: state.url.toString(),
            reqParams: JSON.parse(state.params)
        }
        tracking({ payload: JSONCONSTANT })
        print(`initializeTracking(${JSON.stringify(JSONCONSTANT, null, 2)})`)
    }
    return (
        <>
            <FormGroup check>
                <Input checked={custom.core_data} style={{ fontSize: 16, cursor: "pointer" }} type='checkbox' name='core_data' onChange={(e) => clickCustom(e, "core_data")} color="primary" />
                <Label>Custom Core Data</Label>
                {custom.core_data && <CodeEditor
                    value={state.custom_core_data}
                    onChange={handleChange}
                    name='custom_core_data'
                    minHeight={100}
                    language="JSON"
                    placeholder="Please enter JS code."
                    padding={15}
                    style={{
                        fontFamily:
                            "monospace",
                        fontSize: 12
                    }}
                />}
            </FormGroup>
            <FormGroup check>
                <Input checked={custom.user_data} style={{ fontSize: 16, cursor: "pointer" }} type='checkbox' name='user_data' onChange={(e) => clickCustom(e, "user_data")} color="primary" />
                <Label>Custom User Data</Label>
                {custom.user_data && <CodeEditor
                    value={state.custom_user_data}
                    onChange={handleChange}
                    name='custom_user_data'
                    minHeight={100}
                    language="JSON"
                    placeholder="Please enter JS code."
                    padding={15}
                    style={{
                        fontFamily:
                            "monospace",
                        fontSize: 12
                    }}
                />}
            </FormGroup>
            <FormGroup check>
                <Input checked={custom.marketing_data} style={{ fontSize: 16, cursor: "pointer" }} type='checkbox' name="marketing_data" onChange={(e) => clickCustom(e, "marketing_data")} color="primary" />
                <Label>Custom Marketing Data</Label>
                {custom.marketing_data && <CodeEditor
                    value={state.custom_marketing_data}
                    onChange={handleChange}
                    name='custom_application_data'
                    minHeight={100}
                    language="JSON"
                    placeholder="Please enter JS code."
                    padding={15}
                    style={{
                        fontFamily:
                            "monospace",
                        fontSize: 12
                    }}
                />}
            </FormGroup>
            <FormGroup check>
                <Input checked={custom.application_data} style={{ fontSize: 16, cursor: "pointer" }} type='checkbox' name="application_data" onChange={(e) => clickCustom(e, "application_data")} color="primary" />
                <Label>Custom Application Data</Label>
                {custom.application_data && <CodeEditor
                    value={state.custom_application_data}
                    onChange={handleChange}
                    name='custom_application_data'
                    minHeight={100}
                    language="JSON"
                    placeholder="Please enter JS code."
                    padding={15}
                    style={{
                        fontFamily:
                            "monospace",
                        fontSize: 12
                    }}
                />}
            </FormGroup>
            <FormGroup>
                <Label>url</Label>
                <Input onChange={handleChange} name='url' value={state.url} />
            </FormGroup>
            <FormGroup>
                <Label>Request Params</Label>
                <CodeEditor
                    value={state.params}
                    onChange={handleChange}
                    name='params'
                    minHeight={100}
                    language="JSON"
                    placeholder="Please enter JS code."
                    padding={15}
                    style={{
                        fontFamily:
                            "monospace",
                        fontSize: 12
                    }}
                />
            </FormGroup>
            <div style={{ textAlign: "end" }}>
                <Button type='button' onClick={handleSubmit} color='primary'>Generate</Button>
            </div>
        </>)
}

export default Customize